'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
const _excluded = ["variant", "indicator", "textColor", "children"];
import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { useTabsList, TabsListProvider } from '@mui/base/useTabsList';
import TabsListContext from './TabsListContext';
import { jsx as _jsx } from "react/jsx-runtime";
const FlexContainer = styled('div', {
  name: 'MuiTabs',
  slot: 'FlexContainer',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.flexContainer, ownerState.vertical && styles.flexContainerVertical, ownerState.centered && styles.centered];
  }
})(({
  ownerState
}) => _extends({
  display: 'flex'
}, ownerState.vertical && {
  flexDirection: 'column'
}, ownerState.centered && {
  justifyContent: 'center'
}));

/**
 * @ignore - internal component.
 */
const TabsList = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      variant,
      indicator,
      textColor,
      children
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    getRootProps,
    contextValue
  } = useTabsList(_extends({}, props, {
    rootRef: ref
  }));
  const tabsListContextValue = React.useMemo(() => ({
    indicator,
    textColor,
    fullWidth: variant === 'fullWidth'
  }), [indicator, textColor, variant]);
  return /*#__PURE__*/_jsx(TabsListProvider, {
    value: contextValue,
    children: /*#__PURE__*/_jsx(TabsListContext.Provider, {
      value: tabsListContextValue,
      children: /*#__PURE__*/_jsx(FlexContainer, _extends({}, other, getRootProps(), {
        children: children
      }))
    })
  });
});
process.env.NODE_ENV !== "production" ? TabsList.propTypes = {
  children: PropTypes.node,
  indicator: PropTypes.node,
  textColor: PropTypes.oneOf(['primary', 'secondary']),
  variant: PropTypes.oneOf(['fullWidth', 'scrollable', 'standard'])
} : void 0;
export default TabsList;